import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSnackBarRef, } from '@angular/material/snack-bar';

@Component({
    selector: 'app-popup-conferma-archiviazione',
    imports: [],
    templateUrl: './popup-conferma-archiviazione.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupConfermaArchiviazioneComponent {

  snackBarRef = inject(MatSnackBarRef)

}
